export enum TaxRegime {
    NationalSimple = 1,
    PresumedProfit = 2
}


// WEBPACK FOOTER //
// ./src/app/shared/enums/TaxRegime.ts